import ProductService from '@/services/api/ProductService';

const state = {
  currentProduct: null,
  eagerCreatProductResponse: null,
  submittedProductUrlList: [],
  error: ''
};

const getters = {
  currentProduct: state => state.currentProduct,
  eagerCreatProductResponse: state => state.eagerCreatProductResponse,
  submittedProductUrlList: state => state.submittedProductUrlList
};

const actions = {
  // INFO: Not in use ?
  fetchCurrentProduct({ commit }, productId) {
    return ProductService.get(productId)
      .then((response) => {
        commit('SAVE_CURRENT_PRODUCT_RESPONSE', response.data);
      })
      .catch(error => {
        commit('SAVE_ERROR_RESPONSE', error.message);
      })
  },

  eagerCreateProduct({ state, commit }, productUrl) {
    return ProductService.create(productUrl)
      .then((response) => {
        let payload = { productUrl: productUrl, data: response.data }

        commit('APPEND_TO_SUBMITTED_PRODUCT_URL_LIST', payload);
        commit('SAVE_EAGER_CREATE_PRODUCT_RESPONSE', response.data);
      })
      .catch(error => {
        commit('SAVE_ERROR_RESPONSE', error.message);
      })
  },

  restCurrentProduct({ commit }) {
    commit('SAVE_CURRENT_PRODUCT_RESPONSE', null);
  },

  restEagerCreateProductResponse({ commit }) {
    commit('SAVE_EAGER_CREATE_PRODUCT_RESPONSE', null);
  }
};

const mutations = {
  APPEND_TO_SUBMITTED_PRODUCT_URL_LIST(state, data) {
    state.submittedProductUrlList = state.submittedProductUrlList.concat(data);
  },

  RESET_SUBMITTED_PRODUCT_URL_LIST(state) {
    state.submittedProductUrlList = []
  },

  SAVE_CURRENT_PRODUCT_RESPONSE(state, response) {
    state.currentProduct = response;
  },

  SAVE_EAGER_CREATE_PRODUCT_RESPONSE(state, response) {
    state.eagerCreatProductResponse = response;
  },

  SAVE_ERROR_RESPONSE(state, error) {
    state.error = error;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/product/index.js